/*
Monotype Foundry Platform API
Version 1.0.0

Definition: PatchAiFeedbackRequest

Properties:
  isAccept: boolean
  feedback: string
*/

var PatchAiFeedbackRequest = (function () {
  function validatePatchAiFeedbackRequest (arg) {
    // Validate isAccept
    if (arg.isAccept && !(typeof arg.isAccept === 'boolean')) {
      throw new Error('PatchAiFeedbackRequest.isAccept: Wrong type: Got \'' + (typeof arg.isAccept) + '\', but expected: \'boolean\'')
    }
    // Validate feedback
    if (arg.feedback && !(typeof arg.feedback === 'string')) {
      throw new Error('PatchAiFeedbackRequest.feedback: Wrong type: Got \'' + (typeof arg.feedback) + '\', but expected: \'string\'')
    }
  }
  function buildPatchAiFeedbackRequest (arg) {
    var PatchAiFeedbackRequest = arg
    // Complete isAccept
    // Expected Type: boolean
    PatchAiFeedbackRequest.isAccept = PatchAiFeedbackRequest.isAccept || false
    // Complete feedback
    // Expected Type: string
    PatchAiFeedbackRequest.feedback = PatchAiFeedbackRequest.feedback || ''
    return PatchAiFeedbackRequest
  }
  return {
    validate: validatePatchAiFeedbackRequest,
    build: buildPatchAiFeedbackRequest
  }
})()

module.exports = PatchAiFeedbackRequest
